import React from 'react';
import ReactDOM from 'react-dom/client';
import AppComponent from './AppComponent';
import './styles/main.scss';

//const root = ReactDOM.createRoot(document.getElementById('root'));
//root.render(<AppComponent />);

const mountNode =
	document.getElementById('reactpress-Verifica_Copertura_FiberCop') ||
	document.getElementById('root');

if (mountNode) {
	const root = ReactDOM.createRoot(mountNode);
	root.render(<AppComponent />);
}